import { useGyymClient, useGyymSWR } from '@gyym/sdk-react'
import type { SWRConfiguration } from 'swr'

import { useAuthUser } from '@/modules/Auth'

// お気に入りの絞り込み属性（エリア＋配下施設・アクティビティ）を取得する
export const useFavoriteSearchAttributes = (
  enabled = true,
  options: SWRConfiguration = {},
) => {
  const client = useGyymClient()
  const { isLoggedIn, isEmailVerified } = useAuthUser()

  return useGyymSWR(
    isLoggedIn && isEmailVerified && enabled
      ? client.user.favorites.listSearchAttributes
      : null,
    options,
  )
}
